import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import "../Styles/Profile.css";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import EditIcon from "@mui/icons-material/Edit";
import Loader from "../Components/Loader";
import { Link } from "react-router-dom";

function Profile() {
  const [user, setUser] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem("authToken");

    const fetchUserProfile = async () => {
      try {
        const response = await axios.get("https://api.uniums.com/api/profile", {
          headers: { Authorization: `Bearer ${token}` },
        });

        setUser(response.data);
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };

    fetchUserProfile();
  }, []);

  const handleEditClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const imageURL = URL.createObjectURL(file);
    setSelectedImage(imageURL);
    setIsUploading(true); // Start uploading

    const formData = new FormData();
    formData.append("profilePicture", file);
    formData.append("employeeCode", user.employeeCode);

    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.post(
        "https://api.uniums.com/api/upload-image",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
          }
        }
      );

      setUser(prev => ({
        ...prev,
        profileImage: response.data.profileImage.imageUrl
      }));

    } catch (error) {
      console.error("Error uploading image:", error);
    } finally {
      setIsUploading(false); // Stop loading
      setSelectedImage(null); // Clear selected image
    }
  };

  if (!user) return <Loader />;

  return (
    <div className="profile-container">
      <div className="profile-card fade-in">
        <div className="profile-content">
          <div className="profile-header-new">
            <div className="profile-image-wrapper">
              {isUploading ? (
                <Loader /> // Show loader while uploading
              ) : selectedImage ? (
                <img
                  src={selectedImage}
                  alt="Profile"
                  className="profile-image"
                  onError={() => setSelectedImage(null)}
                />
              ) : user.profileImage ? (
                <img
                  src={user.profileImage}
                  alt="Profile"
                  className="profile-image"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    setUser(prev => ({
                      ...prev,
                      profileImage: null
                    }));
                  }}
                />
              ) : (
                <AccountCircleIcon className="profile_icon" />
              )}
              {!isUploading && ( // Hide edit button while uploading
                <EditIcon
                  className="edit-icon"
                  onClick={handleEditClick}
                />
              )}
            </div>
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              onChange={handleImageChange}
              className="file-input"
              style={{ display: "none" }}
            />

            <h1 className="profile-name">{user.name}</h1>
            <p className="profile-role">{user.role}</p>
          </div>

          <div className="info-grid">
            <div className="info-item">
              <span className="info-label">Email Address</span>
              <span className="info-value">{user.email}</span>
            </div>

            <div className="info-item">
              <span className="info-label">User ID</span>
              <span className="info-value">{user.employeeCode}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Gender</span>
              <span className="info-value">{user.gender || "N/A"}</span>
            </div>

            <div className="info-item">
              <span className="info-label">Organization</span>
              <span className="info-value">{user.organizationName}</span>
            </div>

            <div className="info-item">
              <span className="info-label">Phone Number</span>
              <span className="info-value">{user.organizationContact}</span>
            </div>

            <div className="info-item">
              <span className="info-label">Location</span>
              <span className="info-value">{user.organizationAddress}</span>
            </div>

            <div className="info-item">
              <span className="info-label">Status</span>
              <span
                className="info-value"
                style={{ color: user.active ? "green" : "red", fontWeight: "bold" }}
              >
                {user.active ? "Active" : "Inactive"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">
                <Link to="/change-password">Change Password</Link>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
